// Shopify Variant-Based Product URL Redirection Script
// This script handles automatic redirection when variants are selected

class VariantRedirector {
  constructor() {
    this.productMappings = this.createProductMappings();
    this.currentProductBase = this.getCurrentProductBase();
    this.init();
  }

  // Create product mappings from CSV data
  createProductMappings() {
    const mappings = {
      // RS Decorative Cushion Set variants
      'rs-decorative-cushion': {
        'RS/18': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-18',
        'RS/17': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-17',
        'RS/16': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-16',
        'RS/15': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-15',
        'RS/14': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-14',
        'RS/13': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-13',
        'RS/12': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-12',
        'RS/11': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-11',
        'RS/10': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-10',
        'RS/9': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-9',
        'RS/8': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-8',
        'RS/7': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-7',
        'RS/6': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-6',
        'RS/5': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-5',
        'RS/4': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-4',
        'RS/3': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-3',
        'RS/2': 'rs-decorative-cushion-set-2-pack-throw-pillows-rs-2',
        'RS/1': 'rs-decorative-cushion-set-2-pack-throw-pillows'
      },
      
      // COR Corduroy Pillow Set color variants
      'cor-corduroy-pillow': {
        'Mustard': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-mustard',
        'Anthracite': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-anthracite',
        'Navy Blue': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-navy-blue',
        'Green': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-green',
        'Pink': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-pink',
        'Brick': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-brick',
        'Dark Coffee': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-dark-coffee',
        'Light Coffee': 'cor-corduroy-pillow-set-2-pack-decorative-cushions-light-coffee',
        'Off White': 'cor-corduroy-pillow-set-2-pack-decorative-cushions'
      },

      // COR Custom Color Striped Cylinder Pillow variants
      'cor-custom-color-striped-cylinder': {
        'Anthracite': 'cor-custom-color-striped-cylinder-pillow-anthracite',
        'Navy Blue': 'cor-custom-color-striped-cylinder-pillow-navy-blue',
        'Green': 'cor-custom-color-striped-cylinder-pillow-green',
        'Pink': 'cor-custom-color-striped-cylinder-pillow-pink',
        'Brick': 'cor-custom-color-striped-cylinder-pillow-brick',
        'Mustard': 'cor-custom-color-striped-cylinder-pillow-mustard',
        'Dark Coffee': 'cor-custom-color-striped-cylinder-pillow-dark-coffee',
        'Light Coffee': 'cor-custom-color-striped-cylinder-pillow-light-coffee',
        'Off White': 'cor-custom-color-striped-cylinder-pillow'
      },

      // RS Custom Color Cylinder Bolster Pillow variants
      'rs-custom-color-cylinder-bolster': {
        'RS-18': 'rs-custom-color-cylinder-bolster-pillow-rs-18',
        'RS-17': 'rs-custom-color-cylinder-bolster-pillow-rs-17',
        'RS-16': 'rs-custom-color-cylinder-bolster-pillow-rs-16',
        'RS-15': 'rs-custom-color-cylinder-bolster-pillow-rs-15',
        'RS-14': 'rs-custom-color-cylinder-bolster-pillow-rs-14',
        'RS-13': 'rs-custom-color-cylinder-bolster-pillow-rs-13',
        'RS-12': 'rs-custom-color-cylinder-bolster-pillow-rs-12',
        'RS-11': 'rs-custom-color-cylinder-bolster-pillow-rs-11',
        'RS-10': 'rs-custom-color-cylinder-bolster-pillow-rs-10',
        'RS-9': 'rs-custom-color-cylinder-bolster-pillow-rs-9',
        'RS-8': 'rs-custom-color-cylinder-bolster-pillow-rs-8',
        'RS-7': 'rs-custom-color-cylinder-bolster-pillow-rs-7',
        'RS-6': 'rs-custom-color-cylinder-bolster-pillow-rs-6',
        'RS-5': 'rs-custom-color-cylinder-bolster-pillow-rs-5',
        'RS-4': 'rs-custom-color-cylinder-bolster-pillow-rs-4',
        'RS-3': 'rs-custom-color-cylinder-bolster-pillow-rs-3',
        'RS-2': 'rs-custom-color-cylinder-bolster-pillow-rs-2',
        'RS-1': 'rs-custom-color-cylinder-bolster-pillow'
      },

      // FELIXX Pouf color variants
      'felixx-pouf': {
        'Anthracite': 'felixx-pouf-anthracite',
        'Navy Blue': 'felixx-pouf-navy-blue',
        'Green': 'felixx-pouf-green',
        'Pink': 'felixx-pouf-pink',
        'Brick': 'felixx-pouf-brick',
        'Mustard': 'felixx-pouf-mustard',
        'Dark Coffee': 'felixx-pouf-dark-coffee',
        'Light Coffee': 'felixx-pouf-light-coffee',
        'Off White': 'felixx-pouf'
      },

      // L Form Ultra Comfort Velvet Sofa variants
      'l-form-ultra-comfort-velvet-sofa': {
        'Anthracite': 'l-form-ultra-comfort-velvet-sofa-anthracite',
        'Navy Blue': 'l-form-ultra-comfort-velvet-sofa-navy-blue',
        'Green': 'l-form-ultra-comfort-velvet-sofa-green',
        'Pink': 'l-form-ultra-comfort-velvet-sofa-pink',
        'Brick': 'l-form-ultra-comfort-velvet-sofa-brick',
        'Mustard': 'l-form-ultra-comfort-velvet-sofa-mustard',
        'Dark Coffee': 'l-form-ultra-comfort-velvet-sofa-dark-coffee',
        'Light Coffee': 'l-form-ultra-comfort-velvet-sofa-light-coffee',
        'Off White': 'l-form-ultra-comfort-velvet-sofa'
      },

      // Teddy Corner Sofa Bed variants
      'teddy-l-velvet-cushion': {
        'Anthracite': 'teddy-l-velvet-cushion-anthracite',
        'Navy Blue': 'teddy-l-velvet-cushion-navy-blue',
        'Green': 'teddy-l-velvet-cushion-green',
        'Pink': 'teddy-l-velvet-cushion-pink',
        'Brick': 'teddy-l-velvet-cushion-brick',
        'Mustard': 'teddy-l-velvet-cushion-mustard',
        'Dark Coffe': 'teddy-l-velvet-cushion-dark-coffee',
        'Light Coffee': 'teddy-l-velvet-cushion-kopya',
        'Off White': 'teddy-l-velvet-cushion'
      },

      // Teddy Sofa Bed variants
      'teddy-velvet-cushion': {
        'Anthracite': 'teddy-velvet-cushion-anthracite',
        'Navy Blue': 'teddy-velvet-cushion-navy-blue',
        'Green': 'teddy-velvet-cushion-green',
        'Pink': 'teddy-velvet-cushion-pink',
        'Brick': 'teddy-velvet-cushion-brick',
        'Mustard': 'teddy-velvet-cushion-mustard',
        'Dark Coffee': 'teddy-velvet-cushion-dark-coffee',
        'Light Coffee': 'teddy-velvet-cushion-light-coffee',
        'Off White': 'teddy-velvet-cushion'
      },

      // Custom Bench Seat Cushion Flat RS variants
      'custom-chenille-bench-seat-cushion-plain': {
        'RS-18': 'custom-chenille-bench-seat-cushion-plain-rs-18',
        'RS-17': 'custom-chenille-bench-seat-cushion-plain-rs-17',
        'RS-16': 'custom-chenille-bench-seat-cushion-plain-rs-16',
        'RS-15': 'custom-chenille-bench-seat-cushion-plain-rs-15',
        'RS-14': 'custom-chenille-bench-seat-cushion-plain-rs-14',
        'RS-13': 'custom-chenille-bench-seat-cushion-plain-rs-13',
        'RS-12': 'custom-chenille-bench-seat-cushion-plain-rs-12',
        'RS-11': 'custom-chenille-bench-seat-cushion-plain-rs-11',
        'RS-10': 'custom-chenille-bench-seat-cushion-plain-rs-10',
        'RS-9': 'custom-chenille-bench-seat-cushion-plain-rs-9',
        'RS-8': 'custom-chenille-bench-seat-cushion-plain-rs-8',
        'RS-7': 'custom-chenille-bench-seat-cushion-plain-rs-7',
        'RS-6': 'custom-chenille-bench-seat-cushion-plain-rs-6',
        'RS-5': 'custom-chenille-bench-seat-cushion-plain-rs-5',
        'RS-4': 'custom-chenille-bench-seat-cushion-plain-rs-4',
        'RS-3': 'custom-chenille-bench-seat-cushion-plain-rs-3',
        'RS-2': 'custom-chenille-bench-seat-cushion-plain-2',
        'RS-1': 'custom-chenille-bench-seat-cushion-plain'
      },

      // Custom Bench Seat Cushion RS variants
      'custom-chenille-bench-seat-cushion': {
        'RS-18': 'custom-chenille-bench-seat-cushion-rs-16-kopya',
        'RS-17': 'custom-chenille-bench-seat-cushion-rs-17',
        'RS-16': 'custom-chenille-bench-seat-cushion-rs-16',
        'RS-15': 'custom-chenille-bench-seat-cushion-rs-15',
        'RS-14': 'custom-chenille-bench-seat-cushion-rs-14',
        'RS-13': 'custom-chenille-bench-seat-cushion-rs-13',
        'RS-12': 'custom-chenille-bench-seat-cushion-rs-12',
        'RS-11': 'custom-chenille-bench-seat-cushion-rs-11',
        'RS-10': 'custom-chenille-bench-seat-cushion-rs-10',
        'RS-9': 'custom-chenille-bench-seat-cushion-rs-8-kopya',
        'RS-8': 'custom-chenille-bench-seat-cushion-rs-8',
        'RS-7': 'custom-chenille-bench-seat-cushion-rs-7',
        'RS-6': 'custom-chenille-bench-seat-cushion-rs-6',
        'RS-5': 'custom-chenille-bench-seat-cushion-rs-5',
        'RS-4': 'custom-chenille-bench-seat-cushion-rs-4',
        'RS-3': 'custom-chenille-bench-seat-cushion-rs-3',
        'RS-2': 'custom-chenille-bench-seat-cushion-rs-2',
        'RS-1': 'window-seat-cushion-indoor-custom-bench-cushion-large-floor-cushion-1'
      },

      // Custom Linen Bench Cushion variants
      'custom-linen-bench-cushion': {
        'Linen/7': 'custom-linen-bench-cushion-linen-7',
        'Linen/6': 'custom-linen-bench-cushion-linen-6',
        'Linen/5': 'custom-linen-bench-cushion-linen',
        'Linen/4': 'custom-linen-bench-cushion-linen-4',
        'Linen/3': 'custom-linen-bench-cushion-linen-3',
        'Linen/2': 'custom-linen-bench-cushion-linen-2',
        'Linen/1': 'linen-window-seat-cushion-indoor-cushion-french-style-cushion-floor-cushion'
      },

      // Custom Linen Reading Nook Floor Cushion With Back variants
      'custom-linen-reading-nook-floor-cushion-with-back': {
        'Linen-7': 'custom-linen-reading-nook-floor-cushion-with-back-linen-7',
        'Linen-6': 'custom-linen-reading-nook-floor-cushion-with-back-linen-6',
        'Linen-5': 'custom-linen-reading-nook-floor-cushion-with-back-linen-5',
        'Linen-4': 'custom-linen-reading-nook-floor-cushion-with-back-linen-4',
        'Linen-3': 'custom-linen-reading-nook-floor-cushion-with-back-linen-2-kopya',
        'Linen-2': '2-1-kopya',
        'Linen-1': 'floor-seating-cushion-reading-nook-cushion-custom-large-cushion-with-backrest'
      },

      // Custom Velvet & Cotton Window Seat Cushion Baby variants
      'custom-velvet-cotton-window-seat-cushion': {
        'Baby-6': 'custom-velvet-cotton-window-seat-cushionbaby-24',
        'Baby-4': 'custom-velvet-cotton-window-seat-cushion-baby-7',
        'Baby-3': 'custom-velvet-cotton-window-seat-cushion-baby-4',
        'Baby-2': 'custom-velvet-cotton-window-seat-cushion-baby-2',
        'Baby-1': 'custom-velvet-cotton-window-seat-cushion-baby-1',
        'Baby-26': 'custom-velvet-cotton-window-seat-cushion-baby-26',
        'Baby-25': 'custom-velvet-cotton-window-seat-cushion-baby-25',
        'Baby-24': 'custom-velvet-cotton-window-seat-cushion-baby-23-kopya',
        'Baby-23': 'custom-velvet-cotton-window-seat-cushion-baby-23',
        'Baby-22': 'custom-velvet-cotton-window-seat-cushion-baby-22',
        'Baby-21': 'custom-velvet-cotton-window-seat-cushion-baby-21',
        'Baby-20': 'custom-velvet-cotton-window-seat-cushion-baby-20',
        'Baby-19': 'custom-velvet-cotton-window-seat-cushion-baby-19',
        'Baby-18': 'custom-velvet-cotton-window-seat-cushion-baby-18',
        'Baby-17': 'custom-velvet-cotton-window-seat-cushion-baby-17',
        'Baby-16': 'custom-velvet-cotton-window-seat-cushion-baby-16',
        'Baby-15': 'custom-velvet-cotton-window-seat-cushion-baby-15',
        'Baby-14': 'custom-velvet-cotton-window-seat-cushion-baby-14',
        'Baby-13': 'custom-velvet-cotton-window-seat-cushion-baby-13',
        'Baby-12': 'custom-velvet-cotton-window-seat-cushion-baby-12',
        'Baby-11': 'custom-velvet-cotton-window-seat-cushion-baby-11',
        'Baby-10': 'custom-velvet-cotton-window-seat-cushion-baby-10',
        'Baby-9': 'custom-velvet-cotton-window-seat-cushion-baby-9',
        'Baby-8': 'custom-velvet-cotton-window-seat-cushion-baby-8',
        'Baby-7': 'custom-velvet-cotton-window-seat-cushionbaby-7',
        'Baby-5': 'custom-velvet-cotton-window-seat-cushion-baby-5'
      },

      // Window Seat Cushion Indoor Custom Bench Cushion variants (RS based)
      'window-seat-cushion-indoor-custom-bench-cushion': {
        'RS-1': 'window-seat-cushion-indoor-custom-bench-cushion-large-floor-cushion-1',
        'RS-2': 'custom-chenille-bench-seat-cushion-rs-2',
        'RS-3': 'custom-chenille-bench-seat-cushion-rs-3',
        'RS-4': 'custom-chenille-bench-seat-cushion-rs-4',
        'RS-5': 'custom-chenille-bench-seat-cushion-rs-5',
        'RS-6': 'custom-chenille-bench-seat-cushion-rs-6',
        'RS-7': 'custom-chenille-bench-seat-cushion-rs-7',
        'RS-8': 'custom-chenille-bench-seat-cushion-rs-8',
        'RS-9': 'custom-chenille-bench-seat-cushion-rs-8-kopya',
        'RS-10': 'custom-chenille-bench-seat-cushion-rs-10',
        'RS-11': 'custom-chenille-bench-seat-cushion-rs-11',
        'RS-12': 'custom-chenille-bench-seat-cushion-rs-12',
        'RS-13': 'custom-chenille-bench-seat-cushion-rs-13',
        'RS-14': 'custom-chenille-bench-seat-cushion-rs-14',
        'RS-15': 'custom-chenille-bench-seat-cushion-rs-15',
        'RS-16': 'custom-chenille-bench-seat-cushion-rs-16',
        'RS-17': 'custom-chenille-bench-seat-cushion-rs-17',
        'RS-18': 'custom-chenille-bench-seat-cushion-rs-16-kopya'
      }
    };

    return mappings;
  }

  // Get current product base from URL
  getCurrentProductBase() {
    const path = window.location.pathname;
    const productHandle = path.split('/products/')[1];
    
    if (!productHandle) return null;
    
    // Remove variant parameter if exists
    const baseHandle = productHandle.split('?')[0];
    
    console.log('Current product handle:', baseHandle);
    
    // Determine product family based on handle patterns
    if (baseHandle.includes('rs-decorative-cushion')) {
      return 'rs-decorative-cushion';
    } else if (baseHandle.includes('cor-corduroy-pillow')) {
      return 'cor-corduroy-pillow';
    } else if (baseHandle.includes('cor-custom-color-striped-cylinder')) {
      return 'cor-custom-color-striped-cylinder';
    } else if (baseHandle.includes('rs-custom-color-cylinder-bolster')) {
      return 'rs-custom-color-cylinder-bolster';
    } else if (baseHandle.includes('felixx-pouf')) {
      return 'felixx-pouf';
    } else if (baseHandle.includes('l-form-ultra-comfort-velvet-sofa')) {
      return 'l-form-ultra-comfort-velvet-sofa';
    } else if (baseHandle.includes('teddy-l-velvet-cushion')) {
      return 'teddy-l-velvet-cushion';
    } else if (baseHandle.includes('teddy-velvet-cushion')) {
      return 'teddy-velvet-cushion';
    } else if (baseHandle.includes('custom-chenille-bench-seat-cushion-plain')) {
      return 'custom-chenille-bench-seat-cushion-plain';
    } else if (baseHandle.includes('custom-chenille-bench-seat-cushion')) {
      return 'custom-chenille-bench-seat-cushion';
    } else if (baseHandle.includes('custom-linen-bench-cushion')) {
      return 'custom-linen-bench-cushion';
    } else if (baseHandle.includes('custom-linen-reading-nook-floor-cushion-with-back')) {
      return 'custom-linen-reading-nook-floor-cushion-with-back';
    } else if (baseHandle.includes('custom-velvet-cotton-window-seat-cushion')) {
      return 'custom-velvet-cotton-window-seat-cushion';
    } else if (baseHandle.includes('window-seat-cushion-indoor-custom-bench-cushion-large-floor-cushion')) {
      return 'window-seat-cushion-indoor-custom-bench-cushion';
    }
    
    console.log('No product family match found for:', baseHandle);
    return null;
  }

  // Initialize event listeners
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupListeners());
    } else {
      this.setupListeners();
    }
  }

  // Setup event listeners for variant selection
  setupListeners() {
    // Listen for clicks on variant options inside the popover.
    document.addEventListener('click', (event) => {
      const option = event.target.closest('.popover-listbox__option');
      if (!option) return;

      // Native combined-listing options are rendered as real <a href> links
      // (option_value.product_url). Never interfere with those — let the browser
      // navigate exactly like the entafix / özel-ölçü template does.
      if (option.tagName === 'A' && option.getAttribute('href')) return;

      const radio = option.querySelector('input[type="radio"]');
      if (!radio) return;

      const target = this.resolveTargetUrl(radio);
      if (!target) return; // No redirect target -> leave native behaviour untouched.

      event.preventDefault();
      event.stopPropagation();
      this.redirectTo(target);
    }, true); // Capture phase to catch the event early.

    // Fallback for direct radio button changes (block / swatch UIs).
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target.type === 'radio' && target.name && target.name.includes('option'))) return;

      const url = this.resolveTargetUrl(target);
      if (!url) return; // No target -> don't touch Shopify's native variant switching.

      event.preventDefault();
      event.stopPropagation();
      this.redirectTo(url);
    });

    // Only intercept a product form submit when we actually have somewhere to redirect.
    // Otherwise the native submit (add to cart) must proceed untouched.
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form && form.id && form.id.includes('product-form'))) return;

      const checkedRadio = form.querySelector('input[type="radio"]:checked');
      const url = checkedRadio ? this.resolveTargetUrl(checkedRadio) : null;
      if (!url) return;

      event.preventDefault();
      event.stopPropagation();
      this.redirectTo(url);
    });
  }

  // Resolve the redirect target for a given option input, or null if there is none.
  // Priority: (1) native combined-listing product_url emitted by the theme,
  //           (2) legacy hardcoded CSV mapping.
  resolveTargetUrl(radioInput) {
    if (!radioInput) return null;

    // 1) Native product URL emitted by the theme (data-product-url on the input).
    if (radioInput.dataset && radioInput.dataset.productUrl) {
      return radioInput.dataset.productUrl;
    }

    // 2) Legacy hardcoded mapping (only for the known product families).
    if (this.currentProductBase && this.productMappings[this.currentProductBase]) {
      const selectedVariant = this.getVariantText(radioInput);
      if (selectedVariant) {
        const targetHandle = this.productMappings[this.currentProductBase][selectedVariant];
        if (targetHandle) return `/products/${targetHandle}`;
      }
    }

    return null;
  }

  // Navigate to the resolved target, unless we are already on that exact page.
  redirectTo(target) {
    if (!target) return;

    let dest;
    try {
      dest = new URL(target, window.location.origin);
    } catch (e) {
      return;
    }

    if (dest.pathname === window.location.pathname && dest.search === window.location.search) {
      return; // Already on the correct URL.
    }

    window.location.href = dest.href;
  }

  // Backwards-compatible wrapper kept for any external callers.
  handleVariantChange(radioInput) {
    this.redirectTo(this.resolveTargetUrl(radioInput));
  }

  // Extract variant text from radio input
  getVariantText(radioInput) {
    // First, try the structure with a specific '.sr-only' span inside the label
    let label = radioInput.id ? document.querySelector(`label[for="${radioInput.id}"]`) : radioInput.closest('label');
    if (label) {
      const srOnlySpan = label.querySelector('.sr-only');
      if (srOnlySpan) {
        const srOnlyText = (srOnlySpan.textContent || srOnlySpan.innerText).trim();
        if (srOnlyText) return srOnlyText;
      }
    }

    // Fallback to the original logic for other variant UIs (popovers, simple labels)
    const popoverLabel = radioInput.closest('.popover-listbox__option');
    if (popoverLabel) {
      const textContent = popoverLabel.textContent || popoverLabel.innerText;
      return textContent.trim();
    }

    // Fallback for simple labels where the text and input are together
    const simpleLabel = radioInput.closest('label');
    if (simpleLabel) {
        const textContent = simpleLabel.textContent || simpleLabel.innerText;
        return textContent.trim();
    }

    // Final fallback for other UI patterns
    const formId = radioInput.form?.id;
    if (formId) {
      const selectedSpan = document.querySelector(`[id*="${formId}"][id*="selected-value"]`);
      if (selectedSpan) {
        return selectedSpan.textContent.trim();
      }
    }

    return null;
  }

  // Manual trigger for testing
  triggerRedirect(variantText) {
    if (!this.currentProductBase || !this.productMappings[this.currentProductBase]) {
      console.log('No product base or mappings found');
      return;
    }

    const targetHandle = this.productMappings[this.currentProductBase][variantText];
    
    if (targetHandle) {
      const currentURL = window.location.href;
      const baseURL = currentURL.split('/products/')[0];
      const newURL = `${baseURL}/products/${targetHandle}`;
      
      console.log('Manual redirect to:', newURL);
      window.location.href = newURL;
    } else {
      console.log('No mapping found for variant:', variantText);
    }
  }
}

// Initialize the redirector
new VariantRedirector();